<template>
  <v-dialog v-model="show" persistent max-width="1000px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
            <v-card outlined class="mb-6 pa-4 grey lighten-4">
              <v-row dense>
                <v-col cols="12" md="6">
                  <strong>{{ medioSelected.MEDIO }}</strong>
                  <div class="text--secondary">Tipo: {{ medioSelected.TIPO }}</div>
                  <div class="text--secondary">Base: {{ medioSelected.INFRAESTRUCTURA || 'Sin asignar' }}</div>
                </v-col>

                <v-col cols="12" md="6">
                  <div>
                    Velocidad máxima:
                    <strong>
                      {{ medioSelected.VELOCIDAD_MAX != null
                          ? medioSelected.VELOCIDAD_MAX + ' km/h'
                          : '-' }}
                    </strong>
                  </div>

                  <div>
                    Tiempo máx. vuelo:
                    <strong>
                      {{ medioSelected.TIEMPO_MAX_VUELO != null
                          ? medioSelected.TIEMPO_MAX_VUELO + ' min'
                          : '-' }}
                    </strong>
                  </div>
                </v-col>
              </v-row>
            </v-card>

            <v-card outlined class="mb-6 pa-3 blue lighten-5" v-if="sunrise && sunset">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2" color="grey darken-2">
                    mdi-timer-outline
                  </v-icon>
                  <span class="text--secondary">
                    Ventana de vuelo
                  </span>
                </div>
                <div>
                  {{ sunrise }}h — {{ sunset }}h
                </div>
              </div>
            </v-card>

            <v-form ref="form" v-model="isValidForm">
              <div class="section-title">Destino de operaciones</div>

              <v-row dense class="mb-6">
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="formData.infraestructuraIdSelected"
                    :items="infraestructurasList"
                    item-text="text"
                    item-value="value"
                    label="Base de repostaje inicio"
                    outlined
                    dense
                    :hide-details="true"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="formData.infraestructuraDestinoId"
                    :items="infraestructurasList"
                    item-text="text"
                    item-value="value"
                    label="Base de repostaje final"
                    outlined
                    dense
                    :hide-details="true"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="formData.incendioIdSelected"
                    :items="incendiosList"
                    item-text="text"
                    item-value="value"
                    label="Incendio"
                    outlined
                    dense
                    :hide-details="true"
                  />
                </v-col>
              </v-row>

              <div class="section-title">Tiempos del ciclo</div>

              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="formData.tiempoOperativo"
                    label="Tiempo operativo (min)"
                    type="number"
                    min="0"
                    :rules="[globalRules.nonNegative]"
                    outlined
                    dense
                  />
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="formData.tiempoDescanso"
                    label="Tiempo descanso (min)"
                    type="number"
                    min="0"
                    :rules="[globalRules.nonNegative]"
                    outlined
                    dense
                  />
                </v-col>

                <v-col v-if="!idPlanificacion">
                  <v-text-field
                    v-model="formData.numCiclos"
                    label="Nº de ciclos"
                    type="number"
                    min="1"
                    :rules="[globalRules.nonNegative]"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>

              <div class="section-title">Datos del ciclo</div>

              <v-row dense class="mb-4">
                <v-col cols="4">
                  <vx-date-time-picker
                  v-model="formData.horaMovilizacion"
                  label="Hora movilización"
                  :required="true"
                  />
                </v-col>

                <v-col cols="2">
                  <vx-date-time-picker
                  v-model="formData.horaLlegadaInc"
                  mode="time"
                  label="Llegada al incendio"
                  :required="true"
                  />
                </v-col>

                <v-col cols="2">
                  <vx-date-time-picker
                  v-model="formData.horaEnLugar"
                  mode="time"
                  label="Salida del incendio"
                  :required="true"
                  />
                </v-col>

                <v-col cols="2">
                  <vx-date-time-picker
                  v-model="formData.horaFinalizado"
                  mode="time"
                  label="Llegada a base"
                  :required="true"
                  />
                </v-col>

                <v-col cols="2">
                  <vx-date-time-picker
                  v-model="formData.horaFinDescanso"
                  mode="time"
                  label="Fin descanso"
                  :required="true"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    small
                    color="primary"
                    @click="calcularDatosCiclo"
                    :disabled="!canCalculateCiclo"
                  >
                    Calcular datos del ciclo
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      <v-card-actions>
        <div v-if="formError" class="error-message">
          <i class="mdi mdi-alert-circle-outline"></i>
          {{ formError }}
        </div>
        <v-spacer />
        <v-btn text color="grey" @click="onClickDelete" v-if = 'idPlanificacion'>Eliminar</v-btn>
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green darken-1" :disabled="!isValidForm" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DateTimePicker from '../shared/DateTimePicker.vue'
import DateService, { DayjsUnit, FMT } from '@/helpers/DateService'
import { getSunrise, getSunset } from 'sunrise-sunset-js'
import { defaultCenter, TIEMPO_TRABAJO_MEDIOS } from '@/helpers/constants'
import { calculateDistanceInfraestructuraToIncendio } from '@/helpers/PlanificacionHelper'
export default {
  components: {
    'vx-date-time-picker': DateTimePicker
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    idMedio: {
      type: String,
      default: null
    },
    idPlanificacion: {
      type: String,
      default: null
    },
    fechaInicial: {
      type: String,
      default: null
    }
  },

  data: () => ({
    isValidForm: false,
    formData: {
      idPlanificacion: null,
      idMedio: null,
      infraestructuraIdSelected: null,
      infraestructuraDestinoId: null,
      incendioIdSelected: null,
      horaMovilizacion: null,
      horaLlegadaInc: null,
      horaEnLugar: null,
      horaFinalizado: null,
      horaFinDescanso: null,
      tiempoOperativo: 60,
      tiempoDescanso: 20,
      numCiclos: 1
    },
    formError: null,
    // Tiempos por defecto
    tiempoTrayectoDefault: 15
  }),

  computed: {
    ...mapGetters('medio', ['getMedioByID']),
    ...mapGetters('infraestructura', ['infraestructuras']),
    ...mapGetters('incendio', ['incendiosReduced']),
    ...mapGetters('planificacion', ['getPlanificacionByID']),

    infraestructurasList () {
      return [
        { text: 'Ninguna', value: null },
        ...this.infraestructuras.map(x => ({
          text: x.NOMBRE,
          value: x.ID_INFRAESTRUCTURA
        }))
      ]
    },

    incendiosList () {
      return [
        { text: 'Ninguno', value: null },
        ...this.incendiosReduced.map(x => ({
          text: x.NOMBRE || x.LOCALIDAD,
          value: x.ID_INCENDIO
        }))
      ]
    },

    medioSelected() {
      const m = this.getMedioByID(this.idMedio)
      if (!m) return null

      return {
        ID_MEDIO: m.ID_MEDIO,
        MEDIO: m.MEDIO,
        TIPO: m.TIPO,
        ID_INFRAESTRUCTURA: m.ID_INFRAESTRUCTURA || null,
        INFRAESTRUCTURA: m.INFRAESTRUCTURA || null,
        VELOCIDAD_MAX: m.VELOCIDAD_MAX,
        TIEMPO_MAX_VUELO: m.TIEMPO_MAX_VUELO
      }
    },

    title () {
      const title = this.idPlanificacion ? 'Editar planificacion' : 'Añadir planificacion'
      return title
    },

    sunrise() {
      if (!this.formData.horaMovilizacion) return null
      const date = getSunrise(defaultCenter.lat, defaultCenter.lng, DateService.toDayjs(this.formData.horaMovilizacion, FMT.date).toDate())
      return DateService.toDayjs(date).format(FMT.time)
    },
    sunset() {
      if (!this.formData.horaMovilizacion) return null
      const date = getSunset(defaultCenter.lat, defaultCenter.lng, DateService.toDayjs(this.formData.horaMovilizacion, FMT.date).toDate())
      return DateService.toDayjs(date).format(FMT.time)
    },
    canCalculateCiclo() {
      return Boolean(
        this.formData.horaMovilizacion &&
        this.formData.tiempoOperativo != null &&
        this.formData.tiempoDescanso != null
      )
    }
  },

  mounted() {
    this.initForm()
  },

  methods: {
    initForm() {
      if (this.idPlanificacion) {
        const plan = this.getPlanificacionByID(this.idPlanificacion)
        if (!plan) return
        const tiempoOperativo = DateService.toDayjs(plan.FECHA_FINALIZADO_PLANIF).diff(DateService.toDayjs(plan.FECHA_ALARMADO_PLANIF), DayjsUnit.Minute)
        const tiempoDescanso = DateService.toDayjs(plan.FECHA_FIN_DESCANSO_PLANIF).diff(DateService.toDayjs(plan.FECHA_FINALIZADO_PLANIF), DayjsUnit.Minute)
        this.formData = {
          idPlanificacion: plan.ID_PLANIFICACION_MEDIO,
          idMedio: this.medioSelected.ID_MEDIO,
          infraestructuraIdSelected: plan.ID_INFRAESTRUCTURA || null,
          infraestructuraDestinoId: plan.ID_INFRAESTRUCTURA_DESTINO || null,
          incendioIdSelected: plan.ID_INCENDIO || null,
          horaMovilizacion: DateService.toDayjs(plan.FECHA_ALARMADO_PLANIF).format(FMT.date),
          horaLlegadaInc: DateService.toDayjs(plan.FECHA_EN_CAMINO_PLANIF).format(FMT.time),
          horaEnLugar: DateService.toDayjs(plan.FECHA_EN_LUGAR_PLANIF).format(FMT.time),
          horaFinalizado: DateService.toDayjs(plan.FECHA_FINALIZADO_PLANIF).format(FMT.time),
          horaFinDescanso: DateService.toDayjs(plan.FECHA_FIN_DESCANSO_PLANIF).format(FMT.time),
          tiempoOperativo: tiempoOperativo,
          tiempoDescanso: tiempoDescanso,
          numCiclos: 1
        }
      } else {
        const fechaBase = this.getFechaInicial()
        const minutosViaje = this.tiempoTrayectoDefault
        const tiempoOperativo = TIEMPO_TRABAJO_MEDIOS.OPERATIVO
        const tiempoDescanso = TIEMPO_TRABAJO_MEDIOS.DESCANSO
        const horaLlegadaInc = fechaBase.add(minutosViaje, DayjsUnit.Minute)
        const horaFinalizado = fechaBase.add(tiempoOperativo, DayjsUnit.Minute)
        const horaEnLugar = horaFinalizado.subtract(minutosViaje, DayjsUnit.Minute)
        const horaFinDescanso = horaFinalizado.add(tiempoDescanso, DayjsUnit.Minute)
        this.formData = {
          idPlanificacion: null,
          idMedio: this.medioSelected.ID_MEDIO,
          infraestructuraIdSelected: this.medioSelected.ID_INFRAESTRUCTURA || null,
          infraestructuraDestinoId: this.medioSelected.ID_INFRAESTRUCTURA || null,
          incendioIdSelected: null,
          horaMovilizacion: fechaBase.format(FMT.date),
          horaLlegadaInc: horaLlegadaInc.format(FMT.time),
          horaEnLugar: horaEnLugar.format(FMT.time),
          horaFinalizado: horaFinalizado.format(FMT.time),
          horaFinDescanso: horaFinDescanso.format(FMT.time),
          tiempoOperativo,
          tiempoDescanso,
          numCiclos: 1
        }
      }
    },

    getFechaInicial() {
      const horaActual = DateService.getCurrentDayJs().format(FMT.time)
      const fechaBase = this.fechaInicial
        ? DateService.toDayjs(`${this.fechaInicial} ${horaActual}`, FMT.dateDash)
        : DateService.getCurrentDayJs()
      return fechaBase
    },

    calcularHoraLlegada() {
      if (!this.formData.horaMovilizacion || this.formData.tiempoOperativo == null) {
        return
      }

      let minutosViaje = this.tiempoTrayectoDefault
      if (this.formData.infraestructuraIdSelected && this.formData.incendioIdSelected && this.medioSelected?.VELOCIDAD_MAX != null) {
        const infraestructura = this.infraestructuras.find(x => x.ID_INFRAESTRUCTURA.equalsIgnoreCase(this.formData.infraestructuraIdSelected)) || null
        const incendio = this.incendiosReduced.find(x => x.ID_INCENDIO.equalsIgnoreCase(this.formData.incendioIdSelected)) || null
        const tiempoCalculado = infraestructura && incendio
          ? calculateDistanceInfraestructuraToIncendio(infraestructura, incendio, this.medioSelected.VELOCIDAD_MAX)
          : null
        if (tiempoCalculado || tiempoCalculado === 0) {
          minutosViaje = tiempoCalculado
        }
      }

      const horaMovilizacion = DateService.toDayjs(this.formData.horaMovilizacion, FMT.date)
      const llegada = horaMovilizacion.add(minutosViaje, DayjsUnit.Minute)
      this.formData.horaLlegadaInc = llegada.format(FMT.time)
    },

    calcularHoraEnLugar() {
      if (!this.formData.horaMovilizacion || this.formData.tiempoOperativo == null) {
        return
      }

      let minutosVuelta = this.tiempoTrayectoDefault
      if (this.formData.infraestructuraDestinoId && this.formData.incendioIdSelected && this.medioSelected?.VELOCIDAD_MAX != null) {
        const infraestructura = this.infraestructuras.find(x => x.ID_INFRAESTRUCTURA.equalsIgnoreCase(this.formData.infraestructuraDestinoId)) || null
        const incendio = this.incendiosReduced.find(x => x.ID_INCENDIO.equalsIgnoreCase(this.formData.incendioIdSelected)) || null
        const tiempoCalculado = infraestructura && incendio
          ? calculateDistanceInfraestructuraToIncendio(infraestructura, incendio, this.medioSelected.VELOCIDAD_MAX)
          : null
        if (tiempoCalculado || tiempoCalculado === 0) {
          minutosVuelta = tiempoCalculado
        }
      }

      const horaMovilizacion = DateService.toDayjs(this.formData.horaMovilizacion, FMT.date)
      const horaSalida = horaMovilizacion.add(+this.formData.tiempoOperativo, DayjsUnit.Minute).subtract(minutosVuelta, DayjsUnit.Minute)
      this.formData.horaEnLugar = horaSalida.format(FMT.time)
    },

    calcularHoraFinalizado() {
      if (!this.formData.horaMovilizacion || this.formData.tiempoOperativo == null) {
        return
      }

      const horaMovilizacion = DateService.toDayjs(this.formData.horaMovilizacion, FMT.date)
      const llegadaBase = horaMovilizacion.add(+this.formData.tiempoOperativo, DayjsUnit.Minute)
      this.formData.horaFinalizado = llegadaBase.format(FMT.time)
    },

    calcularHoraFinDescanso() {
      if (!this.formData.horaFinalizado || this.formData.tiempoDescanso == null) {
        return
      }

      const llegadaBase = DateService.toDayjs(this.formData.horaFinalizado, FMT.time)
      const finDescanso = llegadaBase.add(+this.formData.tiempoDescanso, DayjsUnit.Minute)
      this.formData.horaFinDescanso = finDescanso.format(FMT.time)
    },

    calcularDatosCiclo() {
      if (!this.canCalculateCiclo) return

      this.calcularHoraLlegada()
      this.calcularHoraEnLugar()
      this.calcularHoraFinalizado()
      this.calcularHoraFinDescanso()
    },

    clearData() {
      this.formData = {
        infraestructuraIdSelected: null,
        infraestructuraDestinoId: null,
        incendioIdSelected: null,
        horaMovilizacion: null,
        horaLlegadaInc: null,
        horaEnLugar: null,
        horaFinalizado: null,
        horaFinDescanso: null,
        tiempoOperativo: 60,
        tiempoDescanso: 20,
        numCiclos: 1
      }
      this.formError = null
    },

    cancelar () {
      this.clearData()
      this.$emit('aceptar', null)
    },

    aceptar () {
      if (!this.checkFormData()) return
      this.$emit('aceptar', this.formData)
      this.clearData()
    },

    checkFormData() {
      if (!this.isValidForm) return false

      if (!this.validarHoraLlegada()) {
        this.formError = 'La hora de llegada al incendio no puede ser anterior a la movilización'
        return false
      }

      if (!this.validarHoraEnLugar()) {
        this.formError = 'La hora de salida del incendio no puede ser anterior a la llegada al incendio'
        return false
      }

      if (!this.validarHoraFinalizado()) {
        this.formError = 'La hora de llegada a base no puede ser anterior a la salida del incendio'
        return false
      }

      if (!this.validarHoraFinDescanso()) {
        this.formError = 'La hora de fin de descanso no puede ser anterior a la llegada a base'
        return false
      }

      if (!this.validarCiclos()) {
        this.formError = 'El medio termina su actuación fuera de la ventana de vuelo'
        return false
      }
      return true
    },

    validarHoraLlegada() {
      const { horaLlegadaInc, horaMovilizacion } = this.formData
      if (!horaLlegadaInc || !horaMovilizacion) return false

      const movilizacion = DateService.toDayjs(horaMovilizacion, FMT.time)
      const llegada = DateService.toDayjs(horaLlegadaInc, FMT.time)

      return !llegada.isBefore(movilizacion)
    },

    validarHoraEnLugar() {
      const { horaEnLugar, horaLlegadaInc } = this.formData
      if (!horaEnLugar || !horaLlegadaInc) return false

      const llegada = DateService.toDayjs(horaLlegadaInc, FMT.time)
      const enLugar = DateService.toDayjs(horaEnLugar, FMT.time)

      return !enLugar.isBefore(llegada)
    },

    validarHoraFinalizado() {
      const { horaFinalizado, horaEnLugar } = this.formData
      if (!horaFinalizado || !horaEnLugar) return false

      const enLugar = DateService.toDayjs(horaEnLugar, FMT.time)
      const finalizado = DateService.toDayjs(horaFinalizado, FMT.time)

      return !finalizado.isBefore(enLugar)
    },

    validarHoraFinDescanso() {
      const { horaFinDescanso, horaFinalizado } = this.formData
      if (!horaFinDescanso || !horaFinalizado) return false

      const finalizado = DateService.toDayjs(horaFinalizado, FMT.time)
      const finDescanso = DateService.toDayjs(horaFinDescanso, FMT.time)

      return !finDescanso.isBefore(finalizado)
    },

    validarCiclos() {
      const { numCiclos, horaMovilizacion, tiempoOperativo, tiempoDescanso } = this.formData

      if (!horaMovilizacion || !numCiclos || !tiempoOperativo || !tiempoDescanso) return false

      const movilizacion = DateService.toDayjs(horaMovilizacion, FMT.date)
      const tiempoTotal = (+tiempoOperativo + +tiempoDescanso) * +numCiclos

      const finCiclos = movilizacion.add(tiempoTotal, DayjsUnit.Minute)

      const fechaStr = movilizacion.format(FMT.onlyDate)
      const sunriseDate = DateService.toDayjs(`${fechaStr} ${this.sunrise}`, FMT.date)
      const sunsetDate = DateService.toDayjs(`${fechaStr} ${this.sunset}`, FMT.date)

      const dentroVentana = finCiclos.isAfter(sunriseDate) && finCiclos.isBefore(sunsetDate)

      return dentroVentana
    },

    async onClickDelete () {
      try {
        const msg = 'Eliminar la planificación'
        const result = await this.$root.$confirmDialog.open('¿Está seguro?', msg)
        if (result) {
          this.$emit('deletePlanificacion', this.idPlanificacion)
          this.clearData()
        }
      } catch (error) {
        console.error('Error al eliminar la planificación', error)
        this.$notify({
          title: 'Error',
          text: 'No se puede eliminar la planificación',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
  margin-top: 8px;
  color: #424242;
}
.error-message {
  color: rgb(255, 239, 239);
  font-size: 12px;
  background-color: rgb(253, 147, 147);
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px; /* para separar icono y texto si lo pones */
}

</style>
